import withSpacing from '../../decorators/withSpacing/index';
import Label from './Label';
export default withSpacing(Label);
//# sourceMappingURL=index.js.map